import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import VPNFeatures from './components/VPNFeatures';
import Security from './components/Security';
import Contact from './components/Contact';
import Support from './components/Support';
import PrivacyPolicy from './components/PrivacyPolicy';
import Footer from './components/Footer';
import Navbar from './components/Navbar';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar scrolled={scrolled} />
      <Hero />
      <VPNFeatures />
      <Security />
      <Contact />
      <Support />
      <PrivacyPolicy />
      <Footer />
    </div>
  );
}
